var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "campo-fecha" }, [
      _vm._v(
        _vm._s(
          _vm._f("moment")(_vm.documento.fechaRecepcionSii, "DD-MM-YYYY")
        ) + " "
      )
    ]),
    _c("br"),
    _c("span", { staticClass: "hora" }, [
      _vm._v(" a las "),
      _c("strong", [
        _vm._v(
          _vm._s(_vm._f("moment")(_vm.documento.fechaRecepcionSii, "hh:mm"))
        )
      ]),
      _vm._v(" hrs.")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }